<template>
  <div class="result-item-base">
    <h3 v-html="resultData.title" class="result-item-title"></h3>
    <div class="desc-area">
      <p v-if="!isFree" class="is-purchased" v-html="resultData.text"></p>
      <div v-else-if="isFree && !!resultData.text" class="is-free">
        <p v-html="resultData.text"></p>
        <div class="desc-area-free">
          <basic-button
            class="btn-induce-purchase"
            @btn-click="onInducePurchaseClick"
            :has-shadow="false"
          >続きを見る（有料）</basic-button>
          <p class="notice">※￥999（税込）ですべての占い結果が<br>ご覧いただけます</p>
        </div>
      </div>
      <div v-else class="is-free">
        <div class="desc-area-free--full">
          <basic-button
            class="btn-induce-purchase"
            @btn-click="onInducePurchaseClick"
            :has-shadow="false"
          >続きを見る（有料）</basic-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasicButton from './BasicButton'

export default {
  name: 'ResultItem',
  components: {BasicButton},
  props: {
    isFree: {
      type: Boolean,
      default: false,
    },
    resultData: {
      type: Object,
      required: true,
    },
  },

  mounted() {
    // console.log('  => res[%O]', this.resultData)
  },
  methods: {
    onInducePurchaseClick() {
      this.$emit('btn-click')
    }
  }
}</script>

<style scoped lang="scss">
.result-item-base{
  background: #fff;
  border: 1px solid #333233;
  border-radius: 10px;
  padding:24px 20px;
  margin-bottom: 16px;
}
.result-item-title{
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #333233;
  margin:0;
  margin-bottom: 10px;
}

.is-free {
    margin: 0;
}

.desc-area-free{
  background: url('/static/img/yearluck/y2023/result/blur_text.png');
  height: 144px;
  background-size: contain;
  padding: 40px 8px;
  padding-top: 26px;
}
.desc-area-free--full{
  background: url('/static/img/yearluck/y2023/result/blur_text_full.png') ;
  height: 300px;
  padding: 120px 8px;
  background-size: contain;
}
.notice{
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #303030;
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2023/partials/ResultItem.vue